var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivityLog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.988037 7.04267L2.02269 12.9105C2.33438 14.6781 4.02002 15.8584 5.78768 15.5467L9.27995 14.931M0.988037 7.04267L0.799918 5.97579C0.488233 4.20813 1.66853 2.5225 3.43619 2.21081L11.4377 0.799918C13.2054 0.488233 14.891 1.66853 15.2027 3.43619L15.3909 4.50306L0.988037 7.04267ZM15.6561 8.98583V11.4233L17.8228 13.59M22.427 11.4233C22.427 15.1628 19.3956 18.1942 15.6561 18.1942C11.9167 18.1942 8.8853 15.1628 8.8853 11.4233C8.8853 7.68391 11.9167 4.6525 15.6561 4.6525C19.3956 4.6525 22.427 7.68391 22.427 11.4233Z",
    stroke: "#171717",
    strokeOpacity: 0.5,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityLog);
export default __webpack_public_path__ + "static/media/activity_log.d5274511442eabf56380999f62a26ef8.svg";
export { ForwardRef as ReactComponent };